export const excludeHeader = ['noo']

export const excludeFooter = ['login', 'forgot', 'reset']